export class PurchaseConfig {
  numberOfSalesDaysForStock: number;
  stockAlertThresholdDays: number;
  forecastStockAlertThresholdDays: number;
  reorderStockDays: number;

  prefixSupplierOrder: string = 'SUP/{year}/';
  textSupplierOrderHeader: string = '';
  textSupplierOrderFooter: string = '';
  textShippingAddress: string = '';
  supplierOrderEmailCc: string = '';
  attachExcelToSupplierOrderEmail: boolean = true;

  showProductImages?: boolean = true;

  requireSerialSelection?: boolean = true;
  requireBatchSelection?: boolean = true;

  limitQuickReceptionToSupplierProducts?: boolean = true;

  constructor() {
    this.numberOfSalesDaysForStock = 30;
    this.stockAlertThresholdDays = 7;
    this.forecastStockAlertThresholdDays = 14;
    this.reorderStockDays = 14;
    this.showProductImages = true;
    this.requireSerialSelection = true;
    this.requireBatchSelection = true;
    this.limitQuickReceptionToSupplierProducts = true;
  }
}
